// API Configuration - Now using environment variables
// Set your API URLs in .env.development or .env.production

// ============================================================================
// 🌐 API URL Configuration
// ============================================================================
// Switch between LIVE and LOCAL by commenting/uncommenting the appropriate line

// 🔴 LIVE API (Production Server)
export const API_URL: string = process.env.REACT_APP_API_URL || 'http://198.58.123.131:2025';

// 🟢 LOCAL API (For local development - COMMENTED OUT)
// export const API_URL: string = process.env.REACT_APP_API_URL || 'http://192.168.178.20:2025';
// export const API_URL: string = process.env.REACT_APP_API_URL || 'http://localhost:2025';

// ============================================================================
// 📧 Verification API URL (Keep as localhost for now)
// ============================================================================
export const VERIFY_API_URL: string =
  process.env.REACT_APP_VERIFY_API_URL || 'http://localhost:8000';

// Environment info
export const APP_ENV: string = process.env.REACT_APP_ENV || 'development';
export const ENABLE_LOGGING: boolean = process.env.REACT_APP_ENABLE_LOGGING === 'true';
